import { CheckableGroupComponent } from "./chunk-AUZ3GMLH.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/RadioCardGroup/RadioCardGroup.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var RadioCardGroup = _a => {
  var _b = _a,
    {
      children,
      className
    } = _b,
    rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */jsx(CheckableGroupComponent, __spreadProps(__spreadValues({
    className: clsx("pd:radio-card-group", className)
  }, rest), {
    children
  }));
};
var RadioCardGroup_default = RadioCardGroup;
export { RadioCardGroup_default };